function transformApiValidation(errors) {
  return errors.reduce((acc, error) => {
    acc[error.field] = error.message;
    return acc;
  }, {});
}

export {
  transformApiValidation,
}